/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeviceFirmwareUpdateDelete,
  DeviceFirmwareUpdateSetAsNewest,
} from '../models/index';
import {
    DeviceFirmwareUpdateDeleteFromJSON,
    DeviceFirmwareUpdateDeleteToJSON,
    DeviceFirmwareUpdateSetAsNewestFromJSON,
    DeviceFirmwareUpdateSetAsNewestToJSON,
} from '../models/index';

export interface ApiDeviceFirmwareUpdateAddPostRequest {
    file?: Blob;
}

export interface ApiDeviceFirmwareUpdateDeleteDeleteRequest {
    deviceFirmwareUpdateDelete?: DeviceFirmwareUpdateDelete;
}

export interface ApiDeviceFirmwareUpdateDownloadGetRequest {
    blobName?: string;
}

export interface ApiDeviceFirmwareUpdateSetAsNewestPutRequest {
    deviceFirmwareUpdateSetAsNewest?: DeviceFirmwareUpdateSetAsNewest;
}

/**
 * 
 */
export class DeviceFirmwareUpdateApi extends runtime.BaseAPI {

    /**
     */
    async apiDeviceFirmwareUpdateAddPostRaw(requestParameters: ApiDeviceFirmwareUpdateAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/api/DeviceFirmwareUpdate/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiDeviceFirmwareUpdateAddPost(requestParameters: ApiDeviceFirmwareUpdateAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string; }> {
        const response = await this.apiDeviceFirmwareUpdateAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDeviceFirmwareUpdateDeleteDeleteRaw(requestParameters: ApiDeviceFirmwareUpdateDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DeviceFirmwareUpdate/Delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceFirmwareUpdateDeleteToJSON(requestParameters['deviceFirmwareUpdateDelete']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiDeviceFirmwareUpdateDeleteDelete(requestParameters: ApiDeviceFirmwareUpdateDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string; }> {
        const response = await this.apiDeviceFirmwareUpdateDeleteDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDeviceFirmwareUpdateDownloadGetRaw(requestParameters: ApiDeviceFirmwareUpdateDownloadGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters['blobName'] != null) {
            queryParameters['blob_name'] = requestParameters['blobName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DeviceFirmwareUpdate/Download`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiDeviceFirmwareUpdateDownloadGet(requestParameters: ApiDeviceFirmwareUpdateDownloadGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiDeviceFirmwareUpdateDownloadGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDeviceFirmwareUpdateDownloadLatestVersionGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DeviceFirmwareUpdate/DownloadLatestVersion`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiDeviceFirmwareUpdateDownloadLatestVersionGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiDeviceFirmwareUpdateDownloadLatestVersionGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDeviceFirmwareUpdateGetListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DeviceFirmwareUpdate/GetList`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiDeviceFirmwareUpdateGetListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string; }> {
        const response = await this.apiDeviceFirmwareUpdateGetListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDeviceFirmwareUpdateSetAsNewestPutRaw(requestParameters: ApiDeviceFirmwareUpdateSetAsNewestPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/DeviceFirmwareUpdate/SetAsNewest`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeviceFirmwareUpdateSetAsNewestToJSON(requestParameters['deviceFirmwareUpdateSetAsNewest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiDeviceFirmwareUpdateSetAsNewestPut(requestParameters: ApiDeviceFirmwareUpdateSetAsNewestPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string; }> {
        const response = await this.apiDeviceFirmwareUpdateSetAsNewestPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
